// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "2d1ecd9c3789b0e3","191": "6d97bc5190ffc7e3","396": "03f89d67acdd009a","460": "844069243d83eafd","498": "31101ba7e370cf8d","917": "a4976af1894726fc","985": "d5f065492d21d8a6",}[chunkId] + ".chunk.js"
}